import { DataBox, createDataBox, createDataBoxDefault } from 'app/common/data-box-store'
import { ItemType } from 'app/common/ui-next/plain-selector'


type ViewTypes = Array<ItemType>

class ViewTypeFilterDataBox extends DataBox<ViewTypes> { }

export const defaultViewType: ViewTypes = []
export const viewTypeFilter = createDataBox('viewTypeFilter', defaultViewType, ViewTypeFilterDataBox)

export const defaultViewTypeData = () => {
  return [{
    id: 'sum',
    title: 'Сумма',
  }, {
    id: 'quantity',
    title: 'Количество',
  }]
}

viewTypeFilter.updateData(defaultViewTypeData)
viewTypeFilter.setStatusReady()

export const defaultViewTypeSelection: Array<string> = ['sum']
export const viewTypeFilterSelection = createDataBoxDefault<Array<string>>('viewTypeFilterSelection', defaultViewTypeSelection)
